import axios from 'axios';
import { clearGuestData } from './storage';

/**
 * Exchange a Google ID token (GIS) for app JWT via backend.
 * @returns {Promise<{ token: string, user: object }>}
 */
export async function signInWithGoogleIdToken(idToken) {
  const response = await axios.post('/users/auth/social', {
    provider: 'google',
    idToken,
  });

  const user = response.data?.data;
  const token = user?.token;

  if (!token) {
    throw new Error(response.data?.msg || 'Sign-in failed. No token received.');
  }

  clearGuestData();
  localStorage.setItem('token', token);
  localStorage.setItem('passwordSet', 'false');

  return { token, user };
}

export function getGoogleOAuthClientId() {
  return process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
}

export function isGoogleSignInConfigured() {
  return Boolean(getGoogleOAuthClientId());
}
